<template>
    <main-container>
        <h1>
            <typo name="title-30-normal">{{ dico.title }}</typo>
        </h1>
        <v-row>
            <v-col :lg="totalNumberOfSubjects > minNumberOfSubjects ? '8' : '10'">
                <search-panorama-brochure-and-idcc v-model="brochureAndIdcc" :loading="loading" />
            </v-col>
            <v-col align="center" justify="center" lg="2">
                <action
                    with-icon="mdi-filter-variant"
                    @click="openViewFilters"
                    name="submit-dark"
                    :nochevron="true"
                    :disabled="loading"
                >
                    Filtre{{ this.numberOfFiltersApplied > 1 ? "s" : "" }}
                    {{
                        this.numberOfFiltersApplied > 0 ? `( ${this.numberOfFiltersApplied} )` : ""
                    }}
                </action>
            </v-col>

            <v-col align="center" justify="center" lg="2">
                <action
                    v-if="totalNumberOfSubjects > minNumberOfSubjects"
                    with-icon="mdi-table-column-plus-after"
                    @click="openColumnsFilter"
                    name="submit-dark"
                    :nochevron="true"
                    :disabled="loading"
                >
                    Colonnes
                    {{ `${totalNumberOfDisplayedSubjects} / ${totalNumberOfSubjects}` }}
                </action>
            </v-col>
        </v-row>
        <div class="export-link">
            <conventions-vision-panorama-result-export
                v-if="haveConventions"
                :query="query"
                :displayedSubjects="displayedSubjects"
            />
        </div>
        <search-panorama-filters
            v-model="filters"
            :apenafs="apenafs"
            :insurers="insurers"
            :annotationOptions="annotationOptions"
            :displayedSubjectsByType="displayedSubjectsByType"
            :subjects="subjects"
        />
        <search-panorama-columns :subjects="subjects" :displayedSubjects="displayedSubjects" />
    </main-container>
</template>

<script>
import SearchPanoramaBrochureAndIdcc from "./SearchPanoramaBrochureAndIdcc.vue";
import SearchPanoramaFilters from "./SearchPanoramaFilters.vue";
import SearchPanoramaColumns from "./SearchPanoramaColumns.vue";
import ConventionsVisionPanoramaResultExport from "../result-display/result-export/ConventionsVisionPanoramaResultExport.vue";
import { EventBus } from "src/bus/eventBus";
import { groupBy, isEmpty } from "lodash";

export default {
    props: [
        "value",
        "query",
        "annotationOptions",
        "apenafs",
        "subjects",
        "displayedSubjects",
        "insurers",
        "minNumberOfSubjects",
        "haveConventions",
        "loading",
    ],
    components: {
        SearchPanoramaBrochureAndIdcc,
        SearchPanoramaFilters,
        SearchPanoramaColumns,
        ConventionsVisionPanoramaResultExport,
    },
    data() {
        return {
            brochureAndIdcc: this.value.brochureAndIdccValue,
            filters: this.getFilters(),
            numberOfFiltersApplied: this.getNumberOfFiltersApplied(this.value),
            results: null,
            viewFilters: false,
            totalNumberOfSubjects: this.subjects.length,
            totalNumberOfDisplayedSubjects: this.displayedSubjects.length,
            displayedSubjectsByType: this.getDisplayedSubjectsByType(this.displayedSubjects),
        };
    },
    computed: {
        dico() {
            return this.$privateDico.search;
        },
    },
    watch: {
        brochureAndIdcc(brochureAndIdccValue) {
            this.$emit("input", { brochureAndIdccValue, ...this.filters });
        },
        filters(_filters) {
            this.numberOfFiltersApplied = this.getNumberOfFiltersApplied(_filters);
            this.$emit("input", { brochureAndIdccValue: this.brochureAndIdcc, ..._filters });
        },
        displayedSubjects(_displayedSubjects) {
            this.totalNumberOfDisplayedSubjects = _displayedSubjects.length;
            this.displayedSubjectsByType = this.getDisplayedSubjectsByType(_displayedSubjects);
        },
    },
    methods: {
        openViewFilters() {
            EventBus.$emit("openPanoramaFilters", true);
        },
        openColumnsFilter() {
            EventBus.$emit("openPanoramaColumnsFilter", true);
        },
        getFilters() {
            return {
                apenafCode: this.value.apenafCode,
                shortTitle: this.value.shortTitle,
                csps: this.value.csps,
                excludedSubjects: this.value.excludedSubjects,
                insurerCodes: this.value.insurerCodes,
                guarantees: this.value.guarantees,
                insuranceType: this.value.insuranceType,
                des: this.value.des,
                rateUnit: this.value.rateUnit,
                rateValue: this.value.rateValue,
                rateDistributionEmployer: this.value.rateDistributionEmployer,
                rateDistributionEmployee: this.value.rateDistributionEmployee,
                minimumSeniority: this.value.minimumSeniority,
                ceiling: this.value.ceiling,
                floor: this.value.floor,
            };
        },
        getNumberOfFiltersApplied(filters) {
            let total = 0;
            if (filters.apenafCode) total++;
            if (filters.shortTitle) total++;
            if (filters.csps && !isEmpty(filters.csps)) total++;
            if (filters.excludedSubjects && !isEmpty(filters.excludedSubjects)) total++;
            if (filters.insurerCodes) total++;
            if (filters.guarantees) total++;
            if (filters.insuranceType) total++;
            if (filters.des) total++;
            if (filters.rateUnit) total++;
            if (filters.rateValue && filters.rateValue.numberValue) total++;
            if (filters.rateDistributionEmployer && filters.rateDistributionEmployer.numberValue)
                total++;
            if (filters.rateDistributionEmployee && filters.rateDistributionEmployee.numberValue)
                total++;
            if (filters.minimumSeniority && filters.minimumSeniority.numberValue) total++;
            if (filters.ceiling && filters.ceiling.numberValue) total++;
            if (filters.floor && filters.floor.numberValue) total++;
            return total;
        },
        getDisplayedSubjectsByType(subjects) {
            return groupBy(subjects, s => s.type);
        },
    },
};
</script>

<style scoped lang="sass">
.main-container
    position: relative
.export-link
    position: absolute
    right: 0
    top: 12px

.row
    +r(1024)
        flex-direction: column

.loading
    text-align: center
    margin: $grid-gutter 0
</style>
